import { Layout, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

export function Footer() {
  return (
    <AntFooter
      style={{
        marginTop: 32,
        padding: '16px 0',
      }}
    >
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
      }}>
        <Text type="secondary">
          © Pontes — Todos os direitos reservados
        </Text>
        <nav aria-label="Links utilitários">
          <Link
            to="/faq"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 12px',
              borderRadius: 10,
              border: '1px solid transparent',
              background: 'transparent',
              color: 'inherit',
              textDecoration: 'none',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 150ms ease',
            }}
            className="footer-link"
          >
            <QuestionCircleOutlined />
            FAQ
          </Link>
        </nav>
      </div>
    </AntFooter>
  );
}
